/**
 * Service API pour Parties Prenantes
 * (copié de PRIsME_Eleganza, adapté pour PRIsME_BZ)
 */

import { readApiJson } from '../utils/readApiJson';

const API_BASE_URL = '/api/prisme';

export interface PartiePrenante {
  id?: number;
  client_id: number;
  nom: string;
  prenom: string;
  titre_poste?: string;
  organisation?: string;
  email?: string;
  telephone?: string;
  photo_url?: string;
  bio?: string;
  role_principal?: string;
  niveau_experience?: string;
  date_ajout?: string;
  date_creation?: string;
  date_modification?: string;
  actif?: boolean;
  is_user?: boolean;
  acces_prisme_master?: boolean;
  password?: string;
  is_bz?: boolean;
  git_repository_url?: string | null;
  prisme_website_url?: string | null;
  prisme_completed?: boolean;
  avatar_data_base64?: string;
  avatar_mime_type?: string;
  has_avatar?: boolean;
  droits_prisme?: { ajoutes: string[]; retires: string[] };
}

export async function getPartiesPrenantes(clientId: number | 'all' = 2): Promise<PartiePrenante[]> {
  const url =
    clientId === 'all'
      ? `${API_BASE_URL}/parties-prenantes/all`
      : `${API_BASE_URL}/parties-prenantes/${clientId}`;
  const response = await fetch(url, { credentials: 'include' });
  const data = await readApiJson<PartiePrenante[] | { error?: string }>(response);
  if (!response.ok) {
    throw new Error((data as { error?: string })?.error || 'Erreur lors de la récupération des parties prenantes');
  }
  return data as PartiePrenante[];
}

export async function createPartiePrenante(pp: Partial<PartiePrenante>): Promise<any> {
  const response = await fetch(`${API_BASE_URL}/partie-prenante`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(pp),
  });
  const data = await readApiJson<any>(response);
  if (!response.ok) throw new Error(data?.error || 'Erreur lors de la création');
  return data;
}

export async function updatePartiePrenante(ppId: number, updates: Partial<PartiePrenante>): Promise<any> {
  const response = await fetch(`${API_BASE_URL}/partie-prenante/${ppId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(updates),
  });
  const data = await readApiJson<any>(response);
  if (!response.ok) throw new Error(data?.error || 'Erreur lors de la mise à jour');
  return data;
}

export async function deletePartiePrenante(ppId: number): Promise<any> {
  const response = await fetch(`${API_BASE_URL}/partie-prenante/${ppId}`, {
    method: 'DELETE',
    credentials: 'include',
  });
  const data = await readApiJson<any>(response);
  if (!response.ok) throw new Error(data?.error || 'Erreur lors de la suppression');
  return data;
}

export function getPartiePrenanteAvatarUrl(ppId: number): string {
  return `${API_BASE_URL}/partie-prenante/${ppId}/avatar`;
}

export async function downloadPartiePrenanteAvatar(ppId: number, fileName?: string): Promise<void> {
  const url = `${API_BASE_URL}/partie-prenante/${ppId}/avatar/download`;
  const response = await fetch(url);
  if (!response.ok) throw new Error("Erreur lors du téléchargement de l'avatar");

  const blob = await response.blob();
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.download = fileName || `avatar_${ppId}.png`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(downloadUrl);
}
